import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddTestimonialSchema, ITestimonial, ITestimonialState } from './types';

const initialState: ITestimonialState = {
  testimonial: {},
  deleteTestimonial: {},
  addTestimonial: {},
  updateTestimonial: {},
};
const slice = createSlice({
  name: 'testimonial',
  initialState,
  reducers: {
    //
    getTestimonial(state) {
      state.testimonial.status = RequestStatus.RUNNING;
    },
    getTestimonialSuccess(state, action: PayloadAction<ITestimonialState['testimonial']['data']>) {
      state.testimonial.status = RequestStatus.SUCCESS;
      state.testimonial.data = action.payload;
    },
    getTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.testimonial.status = RequestStatus.ERROR;
      state.testimonial.error = action.payload;
    },

    //
    deleteTestimonial(state, action: PayloadAction<{ id: number | undefined }>) {
      state.deleteTestimonial.status = RequestStatus.RUNNING;
    },
    deleteTestimonialSuccess(state) {
      state.deleteTestimonial.status = RequestStatus.SUCCESS;
    },
    deleteTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteTestimonial.status = RequestStatus.ERROR;
      state.deleteTestimonial.error = action.payload;
    },

    //
    addTestimonial(state, action: PayloadAction<IAddTestimonialSchema>) {
      state.addTestimonial.status = RequestStatus.RUNNING;
    },
    addTestimonialSuccess(state, action: PayloadAction<IAddTestimonialSchema>) {
      state.addTestimonial.status = RequestStatus.SUCCESS;
      state.addTestimonial.data = action.payload;
    },
    addTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addTestimonial.status = RequestStatus.ERROR;
      state.addTestimonial.error = action.payload;
    },
    //
    updateTestimonial(state, action: PayloadAction<any>) {
      state.updateTestimonial.status = RequestStatus.RUNNING;
    },
    updateTestimonialSuccess(state, action: PayloadAction<ITestimonial>) {
      state.updateTestimonial.status = RequestStatus.SUCCESS;
      state.updateTestimonial.data = action.payload;
    },
    updateTestimonialFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateTestimonial.status = RequestStatus.ERROR;
      state.updateTestimonial.error = action.payload;
    },
    //
  },
});

export default slice.reducer;
export const {
  getTestimonial,
  getTestimonialFailed,
  getTestimonialSuccess,
  deleteTestimonial,
  deleteTestimonialSuccess,
  deleteTestimonialFailed,
  addTestimonial,
  addTestimonialFailed,
  addTestimonialSuccess,
  updateTestimonial,
  updateTestimonialFailed,
  updateTestimonialSuccess,
} = slice.actions;
